import React from 'react';
import { useAuthStore } from '@/store';
import { useI18n } from '@/components/I18nProvider';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Ban, LogOut } from 'lucide-react';

export default function SuspendedPage() {
  const { logout, suspendedMessage } = useAuthStore();
  const { t } = useI18n();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4" data-testid="suspended-page">
      <Card className="w-full max-w-md">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
            <Ban className="h-10 w-10 text-destructive" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-destructive">{t('accountSuspended')}</h1>
          <p className="mt-3 text-muted-foreground">
            {suspendedMessage || t('suspendedMessage')}
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <Button variant="outline" className="w-full" onClick={logout} data-testid="suspended-logout-btn">
              <LogOut className="mr-2 h-4 w-4" />
              {t('logout')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
